import {
    SENDINGS_SCHEDULES_REQUEST,
    SENDINGS_SCHEDULES_SUCCESS,
    SENDINGS_SCHEDULES_FAILURE,
    SENDINGS_SCHEDULES_INVALIDATE,
    SENDINGS_NOTICES_REQUEST,
    SENDINGS_NOTICES_SUCCESS,
    SENDINGS_NOTICES_FAILURE,
    SENDINGS_NOTICES_INVALIDATE,
    SENDINGS_TEMPLATES_REQUEST,
    SENDINGS_TEMPLATES_SUCCESS,
    SENDINGS_TEMPLATES_FAILURE,
    SENDINGS_TEMPLATE_DETAIL_REQUEST,
    SENDINGS_TEMPLATE_DETAIL_SUCCESS,
    SENDINGS_TEMPLATE_DETAIL_FAILURE,
    SENDINGS_SERVICES_REQUEST,
    SENDINGS_SERVICES_SUCCESS,
    SENDINGS_SERVICES_FAILURE,
    SENDINGS_SAVE_REQUEST,
    SENDINGS_SAVE_SUCCESS,
    SENDINGS_SAVE_FAILURE,
    SENDINGS_RESET
} from "./ActionTypes";

const createInitialState = () => ({
    schedules: {
        items: [],
        loading: false,
        error: null,
        requestId: null,
        objectId: null
    },

    notices: {
        items: [],
        loading: false,
        error: null,
        requestId: null,
        objectId: null
    },

    templates: {
        items: [],
        loading: false,
        error: null,
        requestId: null
    },

    /*
     * Тексты шаблонов по идентификатору. Кэш нужен, потому
     * что в форме шаблон переключают туда-обратно, а каждый
     * текст запрашивается отдельным запросом.
     */
    templateDetails: {
        byId: {}
    },

    /*
     * Платные услуги подключаются для конкретного объекта,
     * поэтому список привязан к objectId так же, как
     * расписания и уведомления.
     */
    services: {
        items: [],
        loading: false,
        error: null,
        requestId: null,
        objectId: null
    },

    save: {
        saving: false,
        error: null
    }
});

const initialState = createInitialState();

const SendingsReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case SENDINGS_SCHEDULES_REQUEST: {
            /*
             * Обновление списка того же объекта не гасит
             * карточки: иначе после удаления или ручной
             * отправки страница мигала бы спиннером.
             * При смене объекта список очищается, чтобы
             * не показать чужие расписания.
             */
            const sameObject = (
                state.schedules.objectId !== null &&
                String(state.schedules.objectId) ===
                String(action.objectId)
            );

            return {
                ...state,

                schedules: {
                    items: sameObject
                        ? state.schedules.items
                        : [],

                    loading: true,
                    error: null,
                    requestId: action.requestId,
                    objectId: action.objectId
                }
            };
        }

        case SENDINGS_SCHEDULES_SUCCESS:
            // Не принимаем результат устаревшего запроса.
            if (
                state.schedules.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                schedules: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId,
                    objectId: state.schedules.objectId
                }
            };

        case SENDINGS_SCHEDULES_FAILURE:
            // Ошибка могла прийти от устаревшего запроса.
            if (
                state.schedules.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                schedules: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить расписания",

                    requestId: action.requestId,
                    objectId: state.schedules.objectId
                }
            };

        /*
         * Сохранение меняет данные на сервере, поэтому
         * список помечается неактуальным: objectId сброшен,
         * и следующий потребитель загрузит его заново.
         */
        case SENDINGS_SCHEDULES_INVALIDATE:
            return {
                ...state,

                schedules: {
                    ...state.schedules,
                    objectId: null
                }
            };

        case SENDINGS_NOTICES_REQUEST: {
            // Логика та же, что и у расписаний.
            const sameObject = (
                state.notices.objectId !== null &&
                String(state.notices.objectId) ===
                String(action.objectId)
            );

            return {
                ...state,

                notices: {
                    items: sameObject
                        ? state.notices.items
                        : [],

                    loading: true,
                    error: null,
                    requestId: action.requestId,
                    objectId: action.objectId
                }
            };
        }

        case SENDINGS_NOTICES_SUCCESS:
            if (
                state.notices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                notices: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId,
                    objectId: state.notices.objectId
                }
            };

        case SENDINGS_NOTICES_FAILURE:
            if (
                state.notices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                notices: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить уведомления",

                    requestId: action.requestId,
                    objectId: state.notices.objectId
                }
            };

        case SENDINGS_NOTICES_INVALIDATE:
            return {
                ...state,

                notices: {
                    ...state.notices,
                    objectId: null
                }
            };

        /*
         * Шаблоны — практически статический справочник.
         * В отличие от расписаний, при повторной загрузке
         * прежние значения не сбрасываются, иначе select
         * в форме на мгновение опустеет.
         */
        case SENDINGS_TEMPLATES_REQUEST:
            return {
                ...state,

                templates: {
                    items: state.templates.items,
                    loading: true,
                    error: null,
                    requestId: action.requestId
                }
            };

        case SENDINGS_TEMPLATES_SUCCESS:
            if (
                state.templates.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                templates: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId
                }
            };

        case SENDINGS_TEMPLATES_FAILURE:
            if (
                state.templates.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                templates: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить шаблоны",

                    requestId: action.requestId
                }
            };

        /*
         * Каждый текст хранится под своим идентификатором,
         * поэтому ответы, пришедшие не по порядку, не мешают
         * друг другу: форма читает запись выбранного шаблона.
         */
        case SENDINGS_TEMPLATE_DETAIL_REQUEST:
            return {
                ...state,

                templateDetails: {
                    byId: {
                        ...state.templateDetails.byId,

                        [action.id]: {
                            description: null,
                            loading: true,
                            error: null
                        }
                    }
                }
            };

        case SENDINGS_TEMPLATE_DETAIL_SUCCESS:
            return {
                ...state,

                templateDetails: {
                    byId: {
                        ...state.templateDetails.byId,

                        [action.id]: {
                            ...action.detail,
                            loading: false,
                            error: null
                        }
                    }
                }
            };

        case SENDINGS_TEMPLATE_DETAIL_FAILURE:
            return {
                ...state,

                templateDetails: {
                    byId: {
                        ...state.templateDetails.byId,

                        [action.id]: {
                            description: null,
                            loading: false,

                            error:
                                action.error ||
                                "Не удалось загрузить текст шаблона"
                        }
                    }
                }
            };

        case SENDINGS_SERVICES_REQUEST: {
            const sameObject = (
                state.services.objectId !== null &&
                String(state.services.objectId) ===
                String(action.objectId)
            );

            return {
                ...state,

                services: {
                    items: sameObject
                        ? state.services.items
                        : [],

                    loading: true,
                    error: null,
                    requestId: action.requestId,
                    objectId: action.objectId
                }
            };
        }

        case SENDINGS_SERVICES_SUCCESS:
            if (
                state.services.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                services: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId,
                    objectId: state.services.objectId
                }
            };

        case SENDINGS_SERVICES_FAILURE:
            if (
                state.services.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                services: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить услуги",

                    requestId: action.requestId,
                    objectId: state.services.objectId
                }
            };

        case SENDINGS_SAVE_REQUEST:
            return {
                ...state,

                save: {
                    saving: true,
                    error: null
                }
            };

        case SENDINGS_SAVE_SUCCESS:
            return {
                ...state,

                save: {
                    saving: false,
                    error: null
                }
            };

        case SENDINGS_SAVE_FAILURE:
            return {
                ...state,

                save: {
                    saving: false,

                    error:
                        action.error ||
                        "Не удалось сохранить расписание"
                }
            };

        case SENDINGS_RESET:
            return createInitialState();

        default:
            return state;
    }
};

export default SendingsReducer;
